import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../configurations/configuration';
import { environment } from '../../../environments/environment';
import { Task } from '../../models/tasks/tasks';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class TasksService {
  task: string;
  constructor(private http: HttpClient) {
    this.task = environment.baseURI + environment.apiUrl + 'getTasks';
  }

  getTasks(filterObj, limit, start) {
    return this.http.get<Task>(this.task + "?filter=" + encodeURIComponent(JSON.stringify(filterObj)) + "&limit=" + limit + "&start=" + start, httpOptions);
  }
}
